// extracted by mini-css-extract-plugin
module.exports = {"form":"Form__form--1u8","submit":"Form__submit--2KG"};